import React from 'react';
import ReactGA from 'react-ga4';

import { PATH, PATH_NAME } from 'constants/Routes';
import { COOKIES_STORAGE_KEY } from 'modules/app/constants';

import useLocalStorage from './useLocalStorage';

const trackingId = process.env.REACT_APP_GOOGLE_TRACKING_ID;

const useAnalytics = () => {
  /** @type {{value: import('modules/app/types').CookiesData}} */
  const { value: cookies } = useLocalStorage({ key: COOKIES_STORAGE_KEY });

  const isCustomize = PATH[PATH_NAME.CUSTOMIZE].match(window.location.pathname);
  const hasConsent = Boolean(!isCustomize && cookies?.ANALYTICS);

  React.useEffect(() => {
    if (trackingId && hasConsent) {
      ReactGA.initialize(trackingId, {
        debug: false,
        titleCase: false,
      });
    }
  }, [hasConsent]);

  const onClick = React.useCallback(
    (analytics, callback) =>
      (...args) => {
        if (typeof callback === 'function') {
          callback(...args);
        }
        if (analytics?.category && analytics?.action) {
          ReactGA.event(analytics);
        }
      },
    []
  );

  return React.useMemo(() => ({
    ga: ReactGA,
    onClick,
  }), [onClick]);
};

export default useAnalytics;
